import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedDataService } from 'ngx-paf-common';



@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private sharedService: SharedDataService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(event=> {
      }, error => {
        if (error instanceof HttpErrorResponse) {
          let httpError = error; 
          
          if (error.status == 500) {
            // Ne gérer que les erreurs 500
            let message:string = error.message;
            if (httpError.error.ExceptionMessage) {
              message = httpError.error.ExceptionMessage;
            }
            this.sharedService.alert( message,null, 'error', 'Erreur Serveur');            
          }
        }
      })
      );
  }
}
